import { ProductsSidebar } from 'src/components/productsSidebar';
import { type IComponent } from 'src/interfaces';

import { shouldDisplayProductsOptions } from './ProductsSideBarController.helper';

interface ProductsSideBarControllerProps {
  componentDetails: IComponent;
  handleChange: (key: any, value: any) => void;
  onToggleProductsDrawer: () => void;
}

export const ProductsSideBarController = ({
  componentDetails,
  onToggleProductsDrawer,
  handleChange,
}: ProductsSideBarControllerProps) => {
  const componentType = componentDetails?.component_type?.name as any;

  return shouldDisplayProductsOptions(
    componentDetails.config?.productsSource,
  ) ? (
    <ProductsSidebar
      componentType={componentType}
      componentConfig={componentDetails.config}
      productCategoryIDs={componentDetails.product_category_id}
      themeId={componentDetails.theme_id}
      onBackClick={onToggleProductsDrawer}
      onChangedComponentConfigField={handleChange}
    />
  ) : null;
};
